import { defineMessages } from '@dragonraider5/react-intl'

export default defineMessages({
  model200: {
    id: 'containers.Applications.Steps.Documents.tips.model200',
    description: 'Label message for model200 uploader',
    defaultMessage:
      `Por favor, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original de la AEAT.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  model100: {
    id: 'containers.Applications.Steps.Documents.tips.model100',
    description: 'Label message for model100 uploader',
    defaultMessage:
      `Por favor, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original de la AEAT.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  model390: {
    id: 'containers.Applications.Steps.Documents.tips.model390',
    description: 'Label message for model390 uploader',
    defaultMessage:
      `Por favor, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original de la AEAT.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  model303: {
    id: 'containers.Applications.Steps.Documents.tips.model303',
    description: 'Label message for model303 uploader',
    defaultMessage:
      `Por favor, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original de la AEAT.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  model425: {
    id: 'containers.Applications.Steps.Documents.tips.model425',
    description: 'Label message for model425 uploader',
    defaultMessage:
      `Por favor, adjunta tu declaración original del impuesto de Canarias.`
  },
  model420: {
    id: 'containers.Applications.Steps.Documents.tips.model420',
    description: 'Label message for model420 uploader',
    defaultMessage:
      `Por favor, adjunta tu declaración original del impuesto de Canarias.`
  },
  model410: {
    id: 'containers.Applications.Steps.Documents.tips.model410',
    description: 'Label message for model410 uploader',
    defaultMessage:
      `Por favor, adjunta tu declaración original del impuesto de Canarias.`
  },
  model130: {
    id: 'containers.Applications.Steps.Documents.tips.model130',
    description: 'Label message for model130 uploader',
    defaultMessage:
      `Si lo dispones, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original de la AEAT.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  balance_closed: {
    id: 'containers.Applications.Steps.Documents.tips.balance_closed',
    description: 'Label message for balance_closed uploader',
    defaultMessage: 'Por favor, adjunta el documento con el balance y cuenta de resultados de tu organización del último año.'
  },
  auditory: {
    id: 'containers.Applications.Steps.Documents.tips.auditory',
    description: 'Label message for auditory uploader',
    defaultMessage:
      `Por favor, adjunta el documento que acredite la útlima auditoría de tu organización.`
  },
  balance: {
    id: 'containers.Applications.Steps.Documents.tips.balance',
    description: 'Label message for balance uploader',
    defaultMessage:
      `Por favor, adjunta el documento con el balance y cuenta de resultados de tu organización de lo que llevamos de año.`
  },
  budget: {
    id: 'containers.Applications.Steps.Documents.tips.budget',
    description: 'Label message for budget uploader',
    defaultMessage:
      `Si dispones de un presupuesto para el año que viene adjuntalo.`
  },
  prevision: {
    id: 'containers.Applications.Steps.Documents.tips.prevision',
    description: 'Label message for prevision uploader',
    defaultMessage:
      `Si dispones de un documento con la previsión para el año que viene por favor adjuntalo.`
  },
  certificateHacienda: {
    id: 'containers.Applications.Steps.Documents.tips.certificateHacienda',
    description: 'Label message for certificateHacienda uploader',
    defaultMessage:
      `Por favor, adjunta un documento que confirma que estás al corriente de pago con Hacienda.`
  },
  certificateSegSocial: {
    id: 'containers.Applications.Steps.Documents.tips.certificateSegSocial',
    description: 'Label message for certificateSegSocial uploader',
    defaultMessage:
      `Por favor, adjunta un documento que confirma que estás al corriente de pago con la Seguridad Social.`
  },
  model347: {
    id: 'containers.Applications.Steps.Documents.tips.model347',
    description: 'Label message for model347 uploader',
    defaultMessage:
      `Si lo dispones, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original de la AEAT.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  rating: {
    id: 'containers.Applications.Steps.Documents.tips.rating',
    description: 'Label message for rating uploader',
    defaultMessage:
      `Si dispones del informe de tasación por favor adjuntelo.`
  },
  invoice: {
    id: 'containers.Applications.Steps.Documents.tips.invoice',
    description: 'Label message for invoice uploader',
    defaultMessage:
      `Si dispones de las factura/s proforma de la inversión que vas a realizar por favor adjuntelas.`
  },
  discount: {
    id: 'containers.Applications.Steps.Documents.tips.discount',
    description: 'Label message for discount uploader',
    defaultMessage:
      `Si dispones del Contrato/resolución subvención/convenio por favor adjuntelo`
  },
  contract: {
    id: 'containers.Applications.Steps.Documents.tips.contract',
    description: 'Label message for contract uploader',
    defaultMessage:
      `Si dispones del Contrato/resolución subvención/convenio por favor adjuntelo.`
  },
  treasury: {
    id: 'containers.Applications.Steps.Documents.tips.treasury',
    description: 'Label message for treasury uploader',
    defaultMessage:
      `Si dispones del cuadro de tesorería por favor adjuntelo.`
  },
  endorsement: {
    id: 'containers.Applications.Steps.Documents.tips.endorsement',
    description: 'Label message for endorsement uploader',
    defaultMessage:
      `Si dispondes del modelo de aval por favor adjuntelo.`
  },
  other: {
    id: 'containers.Applications.Steps.Documents.tips.other',
    description: 'Label message for other uploader',
    defaultMessage:
      `Por favor, si lo deseas adjunta otra información relevante como planes de negocio, dossier informativo de la actividad...`
  },
})

export const tipsNoAeat = defineMessages({
  noAeatmodel200: {
    id: 'containers.Applications.Steps.Documents.tips.noAeatmodel200',
    description: 'Label message for model200 uploader',
    defaultMessage:
      `Por favor, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original del impuesto.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  noAeatmodel100: {
    id: 'containers.Applications.Steps.Documents.tips.noAeatmodel100',
    description: 'Label message for model100 uploader',
    defaultMessage:
      `Por favor, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original del impuesto.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  noAeatmodel390: {
    id: 'containers.Applications.Steps.Documents.tips.noAeatmodel390',
    description: 'Label message for model390 uploader',
    defaultMessage:
      `Por favor, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original del impuesto.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  noAeatmodel303: {
    id: 'containers.Applications.Steps.Documents.tips.noAeatmodel303',
    description: 'Label message for model303 uploader',
    defaultMessage:
      `Por favor, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original del impuesto.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  noAeatmodel347: {
    id: 'containers.Applications.Steps.Documents.tips.noAeatmodel347',
    description: 'Label message for model347 uploader',
    defaultMessage:
      `Si lo dispones, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original del impuesto.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
  noAeatmodel130: {
    id: 'containers.Applications.Steps.Documents.tips.noAeatmodel130',
    description: 'Label message for model130 uploader',
    defaultMessage:
      `Si lo dispones, {uploadType, select,
        csv { introduce el Código Seguro de Verificación de }
        upload { adjunta }
      } tu declaración original del impuesto.
      {uploadType, select,
        csv {<br />
          <a href='https://www.agenciatributaria.es/AEAT.internet/ayuda/CSV.shtml' title='¿Dónde se encuentra el Código Seguro de Verificación de un documento de la AEAT?' target='_blank' rel='noopener noreferrer'>¿Dónde encontrarlo?</a>
        }
        upload {}
      }`
  },
}) 
